
  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {IRowAction} from "@/model/IRowAction";

  // Row action buttons that keep the column narrow: the first `maxInline` actions are shown as icons
  // and the rest go into a "more" menu. A menu holding a single action is pointless, so in that case
  // everything is shown inline.
  @Component({
    name: 'RowActions',
  })
  export default class RowActions extends Vue {

    @Prop({required: true})
    protected actions!: IRowAction[];

    @Prop({default: 2})
    protected maxInline!: number;

    protected get inlineActions(): IRowAction[] {
      return this.actions.length <= this.maxInline + 1 ? this.actions : this.actions.slice(0, this.maxInline);
    }

    protected get menuActions(): IRowAction[] {
      return this.actions.slice(this.inlineActions.length);
    }
  }
